import React, { Component, lazy, Suspense } from 'react';
import { baseUrlApis, FROM_TYPE } from '@/api';
import { MessageUtil } from 'Api/utils/Message.util';
import { apiMap } from 'Pages/eSignCNWebContainer/api';
import styles from './index.module.scss'
import ESignCNDialog from 'Pages/eSignCNWebContainer/components/Dialog';
import { Skeleton } from 'antd';

const ESignCNIframeDialog = lazy(() => import('./components/IframeDialog'));

class ESignCNWebContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: true,
            iframeDialogVisible: false,
            dialogOpts: {
                type: 'Dialog', // Window 用来加载web url的弹框; Dialog 用来展示提示信息的弹框
                title: '',
                msg: '',
                webUrl: '',
                extData: ''
            },
            iframeLoading: true,
            pcDomain: null
        }
        this.windowMessageUtil = null;
        this.handleIframeOnLoad = this.handleIframeOnLoad.bind(this)
    }
    initPostMessageTool(pcDomain) {
        const callback = async (method, data) => {
            if(apiMap[method]) {
                const stateHook = (state) => {
                    state && this.setState(state)
                }
                return apiMap[method]({ ...data, stateHook })
            } else {
                console.log('not exist method', method);
            }
        }
        this.windowMessageUtil = new MessageUtil();
        this.windowMessageUtil.init(callback, FROM_TYPE.WIN_PHANTOM_ESIGNCN_PLUGIN, pcDomain)
        // windowMessageUtil.handleMessage(method, data)
        //     .then(ret => {
        //         console.log('online has receive response', ret)
        //     })
    }
    componentDidMount() {
        baseUrlApis.loadUrlConfig().then(config => {
            let newEsignCNpc = window.location.hostname === 'localhost' ? 'http://localhost:3001' : config.newEsignCNpc;
            if (localStorage.getItem('DevelopAddress')) {
                newEsignCNpc = localStorage.getItem('DevelopAddress');
            }
            this.setState({
                pcDomain: newEsignCNpc
            }, () => {
                this.initPostMessageTool(newEsignCNpc)
            })
        })

    }

    componentWillUnmount() {
        sessionStorage.removeItem('share_qr_code_data')
        this.windowMessageUtil?.destroyMessageTool();
    }

    handleIframeOnLoad() {
        this.setState({
            iframeLoading: false
        })
    }

    get computedIframeUrl() {
        const { pcDomain } = this.state;
        const { iframeUrlPath } = this.props;
        const shareQrCodeData = sessionStorage.getItem('share_qr_code_data');
        let iframeUrl = `${pcDomain}/${iframeUrlPath}?origin=ONLINE_CONTAINER`;
        if (shareQrCodeData) {
            iframeUrl = `${iframeUrl}&share_qr_code_data=${shareQrCodeData}`;
        }
        return iframeUrl;
    }

    render() {
        const { visible, iframeDialogVisible, dialogOpts, iframeLoading } = this.state;
        return <>
            {
                iframeLoading &&
                <div className={styles.skeleton}>
                    <Skeleton active loading={iframeLoading} ></Skeleton>
                </div>
            }
            { visible && <iframe src={this.computedIframeUrl} className={styles.iframe} onLoad={this.handleIframeOnLoad}></iframe>}
            <Suspense fallback={<div>加载中...</div>}>
                { iframeDialogVisible && dialogOpts.type === 'Window' && <ESignCNIframeDialog opts={dialogOpts}></ESignCNIframeDialog> }
                { iframeDialogVisible && dialogOpts.type === 'Dialog' && <ESignCNDialog opts={dialogOpts} visible={iframeDialogVisible} closeDialog={() => this.setState({iframeDialogVisible: false})}/> }
            </Suspense>
        </>
    }
}

export default ESignCNWebContainer;